import { render, staticRenderFns } from "./MypagePaidPlanCompleteModalSection.vue?vue&type=template&id=48c66b54&scoped=true"
import script from "./MypagePaidPlanCompleteModalSection.vue?vue&type=script&lang=js"
export * from "./MypagePaidPlanCompleteModalSection.vue?vue&type=script&lang=js"
import style0 from "./MypagePaidPlanCompleteModalSection.vue?vue&type=style&index=0&id=48c66b54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c66b54",
  null
  
)

export default component.exports